// extracted by mini-css-extract-plugin
export default {"underconstruction":"UnderConstruction_underconstruction__CPmUA"};